import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Stock\GetStockByLocationController::__invoke
* @see app/Http/Controllers/Stock/GetStockByLocationController.php
* @route '/api/location/{location}/stock'
*/
const GetStockByLocationController = (args: { location: string | number } | [location: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockByLocationController.url(args, options),
    method: 'get',
})

GetStockByLocationController.definition = {
    methods: ["get","head"],
    url: '/api/location/{location}/stock',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Stock\GetStockByLocationController::__invoke
* @see app/Http/Controllers/Stock/GetStockByLocationController.php
* @route '/api/location/{location}/stock'
*/
GetStockByLocationController.url = (args: { location: string | number } | [location: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: args.location,
    }

    return GetStockByLocationController.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Stock\GetStockByLocationController::__invoke
* @see app/Http/Controllers/Stock/GetStockByLocationController.php
* @route '/api/location/{location}/stock'
*/
GetStockByLocationController.get = (args: { location: string | number } | [location: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockByLocationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Stock\GetStockByLocationController::__invoke
* @see app/Http/Controllers/Stock/GetStockByLocationController.php
* @route '/api/location/{location}/stock'
*/
GetStockByLocationController.head = (args: { location: string | number } | [location: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetStockByLocationController.url(args, options),
    method: 'head',
})

export default GetStockByLocationController